import React from "react"
import { Drawer, Box } from '@mui/material';
import RedistrictingDataTabs from "./RedistrictingDataTabs";
import DrawerHandle from "./DrawerHandle";
import { MapDrawerOpen, MapDrawerWidth } from "../../atom/atom"
import {
    useRecoilValue,
} from 'recoil';

export default function SidebarDrawer(props) {
    const drawerOpen = useRecoilValue(MapDrawerOpen);
    const drawerWidth = useRecoilValue(MapDrawerWidth)
    const drawerStyles = {
        textAlign: "left",
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            // ml: { xs:"0", sm:"33.3333%", md:"29.166667%", lg:"25%" },
            width: drawerWidth,
            border: "none",
            boxShadow: 1,
            backgroundColor: "grey.light",
        },
    }
    
    return (
        <Drawer
            sx={drawerStyles}
            variant="persistent"
            anchor="right"
            open={drawerOpen}
            transitionDuration={200}
        >
            <Box sx={{ flexDirection: "row", height: "100vh", maxHeight: "100vh", width: drawerWidth }}>
                <DrawerHandle />
                <RedistrictingDataTabs />
            </Box>
        </Drawer>
    )
}
